/* eslint-disable */

/** unique or primary key constraints on table "argo.work_instruction_instance_step_history" */
export enum ArgoWorkInstructionInstanceStepHistoryConstraint {
  /** unique or primary key constraint on columns "work_instruction_instance_step_history_id" */
  WorkInstructionInstanceStepHistoryPkey = 'work_instruction_instance_step_history_pkey'
}

/** select columns of table "argo.work_instruction_instance_step_history" */
export enum ArgoWorkInstructionInstanceStepHistorySelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Status = 'status',
  /** column name */
  WorkInstructionInstanceStepId = 'work_instruction_instance_step_id'
}

/** update columns of table "argo.work_instruction_instance_step_history" */
export enum ArgoWorkInstructionInstanceStepHistoryUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Status = 'status',
  /** column name */
  WorkInstructionInstanceStepId = 'work_instruction_instance_step_id'
}

